import request from '@/apis/axios'
import type { IResponse } from '@/apis/axios/config'
import type {
  CodeCleanupParam,
  CodeCleanupResult,
  NoticePopupResult,
} from '~/apis/common/type'

/**
 * 2.1.1 코드 정리
 */
export const codeCleanup = (
  params?: CodeCleanupParam,
): Promise<IResponse<CodeCleanupResult>> => {
  return request.post({ url: '/jadooApiV1/codeCleanup', data: params })
}

/**
 * 2.1.1 공지 팝업
 */
export const noticePopup = (): Promise<IResponse<NoticePopupResult>> => {
  return request.get({ url: '/jadooApiV1/userPopupInfo' })
}
